"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = __importDefault(require("store"));
var actions_1 = __importDefault(require("./actions"));
var STORED_STATE = function (initialState) {
    var storedState = store_1.default.get('app.tenant');
    if (storedState) {
        return JSON.parse(storedState);
    }
    return initialState;
};
var initialState = __assign({}, STORED_STATE({
    available: [],
}));
function tenantReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case actions_1.default.SET_STATE:
            return __assign(__assign({}, state), action.payload);
        case actions_1.default.GET_STATE:
            return state;
        default:
            return state;
    }
}
exports.default = tenantReducer;
//# sourceMappingURL=reducers.js.map